import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/users/user15.jpg'
import _imports_1 from '@/assets/images/users/user11.jpg'
import _imports_2 from '@/assets/images/users/user6.jpg'
import _imports_3 from '@/assets/images/users/user9.jpg'
import _imports_4 from '@/assets/images/users/user7.jpg'
import _imports_5 from '@/assets/images/users/user8.jpg'
import _imports_6 from '@/assets/images/users/user10.jpg'
import _imports_7 from '@/assets/images/users/user12.jpg'
import _imports_8 from '@/assets/images/users/user13.jpg'
import _imports_9 from '@/assets/images/users/user14.jpg'


const _hoisted_1 = { class: "mb-[25px] text-center" }
const _hoisted_2 = { class: "inline-block mx-[3px]" }
const _hoisted_3 = { class: "inline-block mx-[3px]" }
const _hoisted_4 = { class: "inline-block mx-[3px]" }
const _hoisted_5 = { class: "trezo-card bg-white dark:bg-[#0c1427] mb-[25px] p-[20px] md:p-[25px] rounded-md" }
const _hoisted_6 = { class: "trezo-card-header mb-[20px] md:mb-[25px] flex items-center justify-between" }
const _hoisted_7 = { class: "trezo-card-subtitle" }
const _hoisted_8 = { class: "trezo-card-dropdown relative" }
const _hoisted_9 = { class: "trezo-card-content -mx-[20px] md:-mx-[25px]" }
const _hoisted_10 = { class: "table-responsive overflow-x-auto" }
const _hoisted_11 = { class: "w-full" }
const _hoisted_12 = { class: "text-black dark:text-white" }
const _hoisted_13 = { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }
const _hoisted_14 = { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }
const _hoisted_15 = { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }
const _hoisted_16 = { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }
const _hoisted_17 = { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProfileCard = _resolveComponent("ProfileCard")!
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_Pagination = _resolveComponent("Pagination")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ProfileCard),
    _createElementVNode("ul", _hoisted_1, [
      _createElementVNode("li", _hoisted_2, [
        _createVNode(_component_RouterLink, {
          to: "/profile/user-profile",
          class: "block py-[8.5px] px-[15px] font-medium rounded-md text-primary-500 border border-primary-500 hover:bg-primary-500 hover:text-white"
        }, {
          default: _withCtx(() => _cache[1] || (_cache[1] = [
            _createTextVNode(" Profile ")
          ])),
          _: 1
        })
      ]),
      _createElementVNode("li", _hoisted_3, [
        _createVNode(_component_RouterLink, {
          to: "/profile/profile-teams",
          class: "block py-[8.5px] px-[15px] font-medium rounded-md text-primary-500 border border-primary-500 hover:bg-primary-500 hover:text-white"
        }, {
          default: _withCtx(() => _cache[2] || (_cache[2] = [
            _createTextVNode(" Teams ")
          ])),
          _: 1
        })
      ]),
      _createElementVNode("li", _hoisted_4, [
        _createVNode(_component_RouterLink, {
          to: "/profile/profile-projects",
          class: "block py-[8.5px] px-[15px] font-medium rounded-md text-primary-500 border border-primary-500 hover:bg-primary-500 hover:text-white"
        }, {
          default: _withCtx(() => _cache[3] || (_cache[3] = [
            _createTextVNode(" Projects ")
          ])),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _cache[6] || (_cache[6] = _createElementVNode("div", { class: "trezo-card-title" }, [
          _createElementVNode("h5", { class: "mb-0" }, "My Projects")
        ], -1)),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("button", {
              type: "button",
              class: _normalizeClass({
              'trezo-card-dropdown-btn inline-block transition-all hover:text-primary-500': true,
              active: _ctx.isActive,
            }),
              id: "dropdownToggle",
              onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleActive && _ctx.toggleActive(...args)), ["stop"]))
            }, _cache[4] || (_cache[4] = [
              _createElementVNode("span", { class: "inline-block relative ltr:pr-[17px] ltr:md:pr-[20px] rtl:pl-[17px] rtl:ml:pr-[20px]" }, [
                _createTextVNode(" This Week "),
                _createElementVNode("i", { class: "ri-arrow-down-s-line text-lg absolute ltr:-right-[3px] rtl:-left-[3px] top-1/2 -translate-y-1/2" })
              ], -1)
            ]), 2),
            _cache[5] || (_cache[5] = _createStaticVNode("<ul class=\"trezo-card-dropdown-menu transition-all bg-white shadow-3xl rounded-md top-full py-[15px] absolute ltr:right-0 rtl:left-0 w-[195px] z-[5] dark:bg-dark dark:shadow-none\" data-v-6ce28e3f><li data-v-6ce28e3f><button type=\"button\" class=\"block w-full transition-all text-black ltr:text-left rtl:text-right relative py-[8px] px-[20px] hover:bg-gray-50 dark:text-white dark:hover:bg-black\" data-v-6ce28e3f> This Day </button></li><li data-v-6ce28e3f><button type=\"button\" class=\"block w-full transition-all text-black ltr:text-left rtl:text-right relative py-[8px] px-[20px] hover:bg-gray-50 dark:text-white dark:hover:bg-black\" data-v-6ce28e3f> This Week </button></li><li data-v-6ce28e3f><button type=\"button\" class=\"block w-full transition-all text-black ltr:text-left rtl:text-right relative py-[8px] px-[20px] hover:bg-gray-50 dark:text-white dark:hover:bg-black\" data-v-6ce28e3f> This Month </button></li><li data-v-6ce28e3f><button type=\"button\" class=\"block w-full transition-all text-black ltr:text-left rtl:text-right relative py-[8px] px-[20px] hover:bg-gray-50 dark:text-white dark:hover:bg-black\" data-v-6ce28e3f> This Year </button></li></ul>", 1))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("table", _hoisted_11, [
            _cache[52] || (_cache[52] = _createElementVNode("thead", { class: "text-black dark:text-white" }, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", { class: "font-medium ltr:text-left rtl:text-right px-[20px] py-[11px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 bg-primary-50 dark:bg-[#15203c] whitespace-nowrap" }, " ID "),
                _createElementVNode("th", { class: "font-medium ltr:text-left rtl:text-right px-[20px] py-[11px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 bg-primary-50 dark:bg-[#15203c] whitespace-nowrap" }, " Project Name "),
                _createElementVNode("th", { class: "font-medium ltr:text-left rtl:text-right px-[20px] py-[11px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 bg-primary-50 dark:bg-[#15203c] whitespace-nowrap" }, " Client "),
                _createElementVNode("th", { class: "font-medium ltr:text-left rtl:text-right px-[20px] py-[11px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 bg-primary-50 dark:bg-[#15203c] whitespace-nowrap" }, " Assignees "),
                _createElementVNode("th", { class: "font-medium ltr:text-left rtl:text-right px-[20px] py-[11px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 bg-primary-50 dark:bg-[#15203c] whitespace-nowrap" }, " Budget "),
                _createElementVNode("th", { class: "font-medium ltr:text-left rtl:text-right px-[20px] py-[11px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 bg-primary-50 dark:bg-[#15203c] whitespace-nowrap" }, " Start Date "),
                _createElementVNode("th", { class: "font-medium ltr:text-left rtl:text-right px-[20px] py-[11px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 bg-primary-50 dark:bg-[#15203c] whitespace-nowrap" }, " End Date "),
                _createElementVNode("th", { class: "font-medium ltr:text-left rtl:text-right px-[20px] py-[11px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 bg-primary-50 dark:bg-[#15203c] whitespace-nowrap" }, " Status "),
                _createElementVNode("th", { class: "font-medium ltr:text-left rtl:text-right px-[20px] py-[11px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 bg-primary-50 dark:bg-[#15203c] whitespace-nowrap" }, " Action ")
              ])
            ], -1)),
            _createElementVNode("tbody", _hoisted_12, [
              _createElementVNode("tr", null, [
                _cache[8] || (_cache[8] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                  _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, " #854 ")
                ], -1)),
                _createElementVNode("td", _hoisted_13, [
                  _createVNode(_component_RouterLink, {
                    to: "/project-management/project-overview",
                    class: "inline-block font-medium transition-all text-gray-500 dark:text-gray-400 hover:text-primary-500"
                  }, {
                    default: _withCtx(() => _cache[7] || (_cache[7] = [
                      _createTextVNode(" Project CyberSphere ")
                    ])),
                    _: 1
                  })
                ]),
                _cache[9] || (_cache[9] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, " NovaTech Solutions ", -1)),
                _cache[10] || (_cache[10] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                  _createElementVNode("div", { class: "flex items-center" }, [
                    _createElementVNode("div", { class: "w-[34px] h-[34px] rounded-full ltr:-mr-[13px] rtl:-ml-[13px] border border-white" }, [
                      _createElementVNode("img", {
                        alt: "user-image",
                        class: "rounded-full",
                        src: _imports_0
                      })
                    ]),
                    _createElementVNode("div", { class: "w-[34px] h-[34px] rounded-full ltr:-mr-[13px] rtl:-ml-[13px] border border-white" }, [
                      _createElementVNode("img", {
                        alt: "user-image",
                        class: "rounded-full",
                        src: _imports_1
                      })
                    ]),
                    _createElementVNode("div", { class: "w-[34px] h-[34px] rounded-full ltr:-mr-[13px] rtl:-ml-[13px] border border-white" }, [
                      _createElementVNode("img", {
                        alt: "user-image",
                        class: "rounded-full",
                        src: _imports_2
                      })
                    ]),
                    _createElementVNode("div", { class: "w-[34px] h-[34px] rounded-full ltr:-mr-[13px] rtl:-ml-[13px] border border-white" }, [
                      _createElementVNode("img", {
                        alt: "user-image",
                        class: "rounded-full",
                        src: _imports_3
                      })
                    ]),
                    _createElementVNode("div", { class: "w-[34px] h-[34px] text-xs rounded-full border border-white bg-primary-500 text-white font-medium flex items-center justify-center" }, " +10 ")
                  ])
                ], -1)),
                _cache[11] || (_cache[11] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                  _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, " $4,500 ")
                ], -1)),
                _cache[12] || (_cache[12] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                  _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, " 25 Mar 2024 ")
                ], -1)),
                _cache[13] || (_cache[13] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                  _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, " 25 Apr 2024 ")
                ], -1)),
                _cache[14] || (_cache[14] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                  _createElementVNode("span", { class: "px-[8px] py-[3px] inline-block bg-success-50 dark:bg-[#15203c] text-success-500 rounded-sm font-medium text-xs" }, " Finished ")
                ], -1)),
                _cache[15] || (_cache[15] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                  _createElementVNode("div", { class: "flex items-center gap-[9px]" }, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "text-primary-500 leading-none custom-tooltip",
                      id: "customTooltip",
                      "data-text": "View"
                    }, [
                      _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " visibility ")
                    ]),
                    _createElementVNode("button", {
                      type: "button",
                      class: "text-gray-500 dark:text-gray-400 leading-none custom-tooltip",
                      id: "customTooltip",
                      "data-text": "Edit"
                    }, [
                      _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " edit ")
                    ]),
                    _createElementVNode("button", {
                      type: "button",
                      class: "text-danger-500 leading-none custom-tooltip",
                      id: "customTooltip",
                      "data-text": "Delete"
                    }, [
                      _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " delete ")
                    ])
                  ])
                ], -1))
              ]),
              _createElementVNode("tr", null, [
                _cache[17] || (_cache[17] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                  _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, " #853 ")
                ], -1)),
                _createElementVNode("td", _hoisted_14, [
                  _createVNode(_component_RouterLink, {
                    to: "/project-management/project-overview",
                    class: "inline-block font-medium transition-all text-gray-500 dark:text-gray-400 hover:text-primary-500"
                  }, {
                    default: _withCtx(() => _cache[16] || (_cache[16] = [
                      _createTextVNode(" Digital Oasis Initiative ")
                    ])),
                    _: 1
                  })
                ]),
                _cache[18] || (_cache[18] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, " AlphaWave Innovations ", -1)),
                _cache[19] || (_cache[19] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                  _createElementVNode("div", { class: "flex items-center" }, [
                    _createElementVNode("div", { class: "w-[34px] h-[34px] rounded-full ltr:-mr-[13px] rtl:-ml-[13px] border border-white" }, [
                      _createElementVNode("img", {
                        alt: "user-image",
                        class: "rounded-full",
                        src: _imports_4
                      })
                    ]),
                    _createElementVNode("div", { class: "w-[34px] h-[34px] rounded-full ltr:-mr-[13px] rtl:-ml-[13px] border border-white" }, [
                      _createElementVNode("img", {
                        alt: "user-image",
                        class: "rounded-full",
                        src: _imports_5
                      })
                    ]),
                    _createElementVNode("div", { class: "w-[34px] h-[34px] rounded-full ltr:-mr-[13px] rtl:-ml-[13px] border border-white" }, [
                      _createElementVNode("img", {
                        alt: "user-image",
                        class: "rounded-full",
                        src: _imports_3
                      })
                    ]),
                    _createElementVNode("div", { class: "w-[34px] h-[34px] text-xs rounded-full border border-white bg-primary-500 text-white font-medium flex items-center justify-center" }, " +04 ")
                  ])
                ], -1)),
                _cache[20] || (_cache[20] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                  _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, " $6,800 ")
                ], -1)),
                _cache[21] || (_cache[21] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                  _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, " 20 Mar 2024 ")
                ], -1)),
                _cache[22] || (_cache[22] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                  _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, " 20 Apr 2024 ")
                ], -1)),
                _cache[23] || (_cache[23] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                  _createElementVNode("span", { class: "px-[8px] py-[3px] inline-block bg-danger-50 dark:bg-[#15203c] text-danger-500 rounded-sm font-medium text-xs" }, " In Progress ")
                ], -1)),
                _cache[24] || (_cache[24] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                  _createElementVNode("div", { class: "flex items-center gap-[9px]" }, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "text-primary-500 leading-none custom-tooltip",
                      id: "customTooltip",
                      "data-text": "View"
                    }, [
                      _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " visibility ")
                    ]),
                    _createElementVNode("button", {
                      type: "button",
                      class: "text-gray-500 dark:text-gray-400 leading-none custom-tooltip",
                      id: "customTooltip",
                      "data-text": "Edit"
                    }, [
                      _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " edit ")
                    ]),
                    _createElementVNode("button", {
                      type: "button",
                      class: "text-danger-500 leading-none custom-tooltip",
                      id: "customTooltip",
                      "data-text": "Delete"
                    }, [
                      _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " delete ")
                    ])
                  ])
                ], -1))
              ]),
              _createElementVNode("tr", null, [
                _cache[26] || (_cache[26] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                  _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, " #852 ")
                ], -1)),
                _createElementVNode("td", _hoisted_15, [
                  _createVNode(_component_RouterLink, {
                    to: "/project-management/project-overview",
                    class: "inline-block font-medium transition-all text-gray-500 dark:text-gray-400 hover:text-primary-500"
                  }, {
                    default: _withCtx(() => _cache[25] || (_cache[25] = [
                      _createTextVNode(" CloudScape Evolution ")
                    ])),
                    _: 1
                  })
                ]),
                _cache[27] || (_cache[27] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, " InnovateIQ Inc. ", -1)),
                _cache[28] || (_cache[28] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                  _createElementVNode("div", { class: "flex items-center" }, [
                    _createElementVNode("div", { class: "w-[34px] h-[34px] rounded-full ltr:-mr-[13px] rtl:-ml-[13px] border border-white" }, [
                      _createElementVNode("img", {
                        alt: "user-image",
                        class: "rounded-full",
                        src: _imports_6
                      })
                    ]),
                    _createElementVNode("div", { class: "w-[34px] h-[34px] rounded-full ltr:-mr-[13px] rtl:-ml-[13px] border border-white" }, [
                      _createElementVNode("img", {
                        alt: "user-image",
                        class: "rounded-full",
                        src: _imports_7
                      })
                    ]),
                    _createElementVNode("div", { class: "w-[34px] h-[34px] text-xs rounded-full border border-white bg-primary-500 text-white font-medium flex items-center justify-center" }, " +07 ")
                  ])
                ], -1)),
                _cache[29] || (_cache[29] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                  _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, " $2,500 ")
                ], -1)),
                _cache[30] || (_cache[30] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                  _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, " 15 Mar 2024 ")
                ], -1)),
                _cache[31] || (_cache[31] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                  _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, " 15 Apr 2024 ")
                ], -1)),
                _cache[32] || (_cache[32] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                  _createElementVNode("span", { class: "px-[8px] py-[3px] inline-block bg-purple-50 dark:bg-[#15203c] text-purple-500 rounded-sm font-medium text-xs" }, " Pending ")
                ], -1)),
                _cache[33] || (_cache[33] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                  _createElementVNode("div", { class: "flex items-center gap-[9px]" }, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "text-primary-500 leading-none custom-tooltip",
                      id: "customTooltip",
                      "data-text": "View"
                    }, [
                      _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " visibility ")
                    ]),
                    _createElementVNode("button", {
                      type: "button",
                      class: "text-gray-500 dark:text-gray-400 leading-none custom-tooltip",
                      id: "customTooltip",
                      "data-text": "Edit"
                    }, [
                      _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " edit ")
                    ]),
                    _createElementVNode("button", {
                      type: "button",
                      class: "text-danger-500 leading-none custom-tooltip",
                      id: "customTooltip",
                      "data-text": "Delete"
                    }, [
                      _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " delete ")
                    ])
                  ])
                ], -1))
              ]),
              _createElementVNode("tr", null, [
                _cache[35] || (_cache[35] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                  _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, " #851 ")
                ], -1)),
                _createElementVNode("td", _hoisted_16, [
                  _createVNode(_component_RouterLink, {
                    to: "/project-management/project-overview",
                    class: "inline-block font-medium transition-all text-gray-500 dark:text-gray-400 hover:text-primary-500"
                  }, {
                    default: _withCtx(() => _cache[34] || (_cache[34] = [
                      _createTextVNode(" Data Dynamo Drive ")
                    ])),
                    _: 1
                  })
                ]),
                _cache[36] || (_cache[36] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, " BlueSky Technologies ", -1)),
                _cache[37] || (_cache[37] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                  _createElementVNode("div", { class: "flex items-center" }, [
                    _createElementVNode("div", { class: "w-[34px] h-[34px] rounded-full ltr:-mr-[13px] rtl:-ml-[13px] border border-white" }, [
                      _createElementVNode("img", {
                        alt: "user-image",
                        class: "rounded-full",
                        src: _imports_8
                      })
                    ]),
                    _createElementVNode("div", { class: "w-[34px] h-[34px] rounded-full ltr:-mr-[13px] rtl:-ml-[13px] border border-white" }, [
                      _createElementVNode("img", {
                        alt: "user-image",
                        class: "rounded-full",
                        src: _imports_9
                      })
                    ]),
                    _createElementVNode("div", { class: "w-[34px] h-[34px] rounded-full ltr:-mr-[13px] rtl:-ml-[13px] border border-white" }, [
                      _createElementVNode("img", {
                        alt: "user-image",
                        class: "rounded-full",
                        src: _imports_0
                      })
                    ]),
                    _createElementVNode("div", { class: "w-[34px] h-[34px] rounded-full ltr:-mr-[13px] rtl:-ml-[13px] border border-white" }, [
                      _createElementVNode("img", {
                        alt: "user-image",
                        class: "rounded-full",
                        src: _imports_7
                      })
                    ]),
                    _createElementVNode("div", { class: "w-[34px] h-[34px] text-xs rounded-full border border-white bg-primary-500 text-white font-medium flex items-center justify-center" }, " +15 ")
                  ])
                ], -1)),
                _cache[38] || (_cache[38] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                  _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, " $7,500 ")
                ], -1)),
                _cache[39] || (_cache[39] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                  _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, " 10 Mar 2024 ")
                ], -1)),
                _cache[40] || (_cache[40] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                  _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, " 10 Apr 2024 ")
                ], -1)),
                _cache[41] || (_cache[41] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                  _createElementVNode("span", { class: "px-[8px] py-[3px] inline-block bg-danger-50 dark:bg-[#15203c] text-danger-500 rounded-sm font-medium text-xs" }, " In Progress ")
                ], -1)),
                _cache[42] || (_cache[42] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                  _createElementVNode("div", { class: "flex items-center gap-[9px]" }, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "text-primary-500 leading-none custom-tooltip",
                      id: "customTooltip",
                      "data-text": "View"
                    }, [
                      _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " visibility ")
                    ]),
                    _createElementVNode("button", {
                      type: "button",
                      class: "text-gray-500 dark:text-gray-400 leading-none custom-tooltip",
                      id: "customTooltip",
                      "data-text": "Edit"
                    }, [
                      _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " edit ")
                    ]),
                    _createElementVNode("button", {
                      type: "button",
                      class: "text-danger-500 leading-none custom-tooltip",
                      id: "customTooltip",
                      "data-text": "Delete"
                    }, [
                      _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " delete ")
                    ])
                  ])
                ], -1))
              ]),
              _createElementVNode("tr", null, [
                _cache[44] || (_cache[44] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                  _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, " #850 ")
                ], -1)),
                _createElementVNode("td", _hoisted_17, [
                  _createVNode(_component_RouterLink, {
                    to: "/project-management/project-overview",
                    class: "inline-block font-medium transition-all text-gray-500 dark:text-gray-400 hover:text-primary-500"
                  }, {
                    default: _withCtx(() => _cache[43] || (_cache[43] = [
                      _createTextVNode(" QuantumLeap Quest ")
                    ])),
                    _: 1
                  })
                ]),
                _cache[45] || (_cache[45] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, " NexGen Systems ", -1)),
                _cache[46] || (_cache[46] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                  _createElementVNode("div", { class: "flex items-center" }, [
                    _createElementVNode("div", { class: "w-[34px] h-[34px] rounded-full ltr:-mr-[13px] rtl:-ml-[13px] border border-white" }, [
                      _createElementVNode("img", {
                        alt: "user-image",
                        class: "rounded-full",
                        src: _imports_4
                      })
                    ]),
                    _createElementVNode("div", { class: "w-[34px] h-[34px] rounded-full ltr:-mr-[13px] rtl:-ml-[13px] border border-white" }, [
                      _createElementVNode("img", {
                        alt: "user-image",
                        class: "rounded-full",
                        src: _imports_3
                      })
                    ]),
                    _createElementVNode("div", { class: "w-[34px] h-[34px] rounded-full ltr:-mr-[13px] rtl:-ml-[13px] border border-white" }, [
                      _createElementVNode("img", {
                        alt: "user-image",
                        class: "rounded-full",
                        src: _imports_2
                      })
                    ]),
                    _createElementVNode("div", { class: "w-[34px] h-[34px] text-xs rounded-full border border-white bg-primary-500 text-white font-medium flex items-center justify-center" }, " +03 ")
                  ])
                ], -1)),
                _cache[47] || (_cache[47] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                  _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, " $3,400 ")
                ], -1)),
                _cache[48] || (_cache[48] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                  _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, " 05 Mar 2024 ")
                ], -1)),
                _cache[49] || (_cache[49] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                  _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, " 05 Apr 2024 ")
                ], -1)),
                _cache[50] || (_cache[50] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                  _createElementVNode("span", { class: "px-[8px] py-[3px] inline-block bg-success-50 dark:bg-[#15203c] text-success-500 rounded-sm font-medium text-xs" }, " Finished ")
                ], -1)),
                _cache[51] || (_cache[51] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                  _createElementVNode("div", { class: "flex items-center gap-[9px]" }, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "text-primary-500 leading-none custom-tooltip",
                      id: "customTooltip",
                      "data-text": "View"
                    }, [
                      _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " visibility ")
                    ]),
                    _createElementVNode("button", {
                      type: "button",
                      class: "text-gray-500 dark:text-gray-400 leading-none custom-tooltip",
                      id: "customTooltip",
                      "data-text": "Edit"
                    }, [
                      _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " edit ")
                    ]),
                    _createElementVNode("button", {
                      type: "button",
                      class: "text-danger-500 leading-none custom-tooltip",
                      id: "customTooltip",
                      "data-text": "Delete"
                    }, [
                      _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " delete ")
                    ])
                  ])
                ], -1))
              ])
            ])
          ])
        ]),
        _createVNode(_component_Pagination, {
          items: "5",
          total: "36",
          class: "px-[20px] md:px-[25px] pt-[12px] md:pt-[14px]"
        })
      ])
    ])
  ], 64))
}